// 计算api接口的基本地址
let hostname = location.hostname;
hostname = hostname.substring(hostname.indexOf('.'));
let appHost = `${location.protocol}//api${hostname}`;
const baseUrl = `${appHost}/zmtx/`;
import axios from 'axios'

//获取医生信息
export function doctorGetDetail(data) {
  return axios.get(`${baseUrl}doctor/get-detail`, data)
}

//医生注册/登录
export function doctorLogin(data) {
  return axios.post(`${baseUrl}doctor/login`, data)
}

//是否同步医师公益平台信息
export function syncErecipelDoctor(data) {
  return axios.post(`${baseUrl}doctor/sync-erecipel-doctor`, data)
}

//医生退出登录
export function doctorLogout(data) {
  return axios.post(`${baseUrl}doctor/logout`, data)
}

//医生完善信息
export function doctorComplete(data) {
  return axios.post(`${baseUrl}doctor/complete`, data)
}

//医生上传材料
export function doctorAttachUpload(data) {
  return axios.post(`${baseUrl}doctor-attach/upload`, data)
}

//医生删除材料
export function doctorAttachRemove(data) {
  return axios.post(`${baseUrl}doctor-attach/remove`, data)
}

//医生获取医院
export function papGetHospital(data) {
  return axios.post(`${baseUrl}pap/get-hospital`, data)
}

//医生获取项目部门、职称数据
export function getDepartmentJob(data) {
  return axios.get(`${baseUrl}config/get-department-job`, data)
}

//获取考题视频
export function getVideos(data) {
  return axios.get(`${baseUrl}videos`, data)
}

//发送验证码
export function SendVerifyCode(data) {
  return axios.post(`${baseUrl}sms/sendverifycode`, data)
}

//获取考题
export function getQuestions(data) {
  return axios.get(`${baseUrl}exam/get-questions`, data)
}

//提交试卷
export function examRecord(data) {
  return axios.post(`${baseUrl}exam-record/exam`, data)
}

//提交备案表
export function recordSubmit(data) {
  return axios.post(`${baseUrl}record-attach/submit`, data)
}

//提交签收表
export function signSubmit(data) {
  return axios.post(`${baseUrl}sign-attach/submit`, data)
}

//医生上传备案表(pc)
export function recordUploadPc(data) {
  return axios.post(`${baseUrl}record-attach/upload-pc`, data)
}

//医生上传签收表(pc)
export function signUploadPc(data) {
  return axios.post(`${baseUrl}sign-attach/upload-pc`, data)
}

//医生删除备案表
export function recordRemove(data) {
  return axios.post(`${baseUrl}record-attach/remove`, data)
}

//医生删除签收表
export function signRemove(data) {
  return axios.post(`${baseUrl}sign-attach/remove`, data)
}

//获取项目医生理解备忘录
export function configGetMemo(data) {
  return axios.get(`${baseUrl}config/get-memo`, data)
}

// 阅读备忘录
export function readMemo(data) {
  return axios.get(`${baseUrl}doctor/read-record`, data)
}